import "jquery-match-height";

$("body").on("click", ".page-scroll", (c) => {
  const a = $(this);
  const _opened = $(".navbar-collapse").hasClass("collapse in");
  if (_opened === true) {
    $("button.navbar-toggle").trigger("click");
  }
  $("html, body")
    .stop()
    .animate(
      {
        scrollTop: $(a.attr("href")).offset().top - 100,
      },
      1500,
      "easeInOutExpo"
    );
  c.preventDefault();
});

$('.page-scroll__phone [data-toggle="tooltip"]').tooltip();

$(".scrollTop").on("click", "a.btn-up", function (e) {
  e.preventDefault();
  $("html, body").stop().animate(
    {
      scrollTop: 0,
    },
    1500,
    "easeInOutExpo"
  );
});

$("#email-address-home-2").on("focus", function () {
  $("#btn-signup-form-2").button("reset");
});

$("a.scroll-to").on("click", function (e) {
  if (this.hash !== "") {
    e.preventDefault();
    var hash = this.hash;

    $("html, body").animate(
      {
        scrollTop: $(hash).offset().top - $("nav.navbar").outerHeight(),
      },
      800,
      function () {
        window.location.hash = hash;
      }
    );
  }
});

$(".btn-intercom").on("click", function (e) {
  e.preventDefault();
  if (typeof Intercom == "function") {
    Intercom("showNewMessage");
  }
});

$("#btn-signupnow").on("click", function () {
  $("html, body").animate(
    {
      scrollTop: 0,
    },
    1000
  );
});

$("#vip").popover({
  html: true,
  trigger: "hover focus",
  template:
    '<div class="popover" role="tooltip"><div class="arrow"></div><h3 class="popover-title" style="font-size: 16px; text-align: center;" ></h3><div class="popover-content" style="text-align: center;"></div></div>',
});

$("section#comparison p").matchHeight();
$(".equalH").matchHeight();
$("#intro6-slider h2").matchHeight();

$(window).scroll(function () {
  var s = $(window).scrollTop(),
    d = $(document).height(),
    c = $(window).height();

  var scrollPercent = (s / (d - c)) * 100;

  if (scrollPercent >= 2) {
    $(".scrollTop").css("transform", "scale(1)");
  } else {
    $(".scrollTop").css("transform", "scale(0)");
  }
});

$("img.lazy").show();
$("h2.lazy").show();
